// extracted by mini-css-extract-plugin
export default {"main":"FormInput_main__7-+I0","invalid":"FormInput_invalid__P584m","error-msg":"FormInput_error-msg__LoF4k"};